module.exports = __webpack_public_path__ + "static/media/event_approval_white.d5ae8d8e.svg";